import { Sliced3DFileLoader } from "./sliced-3d-fileLoader";

export class Sliced3D {
    private readonly scopes: NodeListOf<HTMLElement>;
    private static _instance: Sliced3D;

    private constructor() {
        this.scopes = document.querySelectorAll('.scope-dlp') as NodeListOf<HTMLElement>;
        
        if(!this.scopes) {
            return;
        }

        document.addEventListener("DOMContentLoaded", () => {
            this.initSliced3DComponent();
        });
    }

    static get instance() {
        return this._instance || (this._instance = new this());
    }
    
    private initSliced3DComponent() : void {
        const scopesArray: Array<HTMLElement> = Array.prototype.slice.call(this.scopes);
        
        for (const scope of scopesArray)
        {
            let sliced3DViews: NodeListOf<HTMLElement> = scope.querySelectorAll('.dlp_scs_first_image') as NodeListOf<HTMLElement>;

            if(sliced3DViews && sliced3DViews.length > 0) {
                const imageContainers: Array<HTMLElement> = Array.prototype.slice.call(sliced3DViews);

                for (const imageContainer of imageContainers) {
                    this.addSliced3DEx(imageContainer);
                }
            }
        }
    }

    private addSliced3DEx(imageContainer: HTMLElement) {
        const slicedImage = imageContainer.querySelector('.scs_first_image') as HTMLImageElement;

        if(slicedImage) {
            const naturalWidth: number = slicedImage.naturalWidth / 2;
            imageContainer.style.width = naturalWidth.toString() + 'px';
        }
    }

    private addSliced3D(sliced3DView: HTMLElement, imageUrl: string) {
        const slicedImage = document.createElement("img");
        slicedImage.src = imageUrl;
        sliced3DView.getElementsByTagName('div')[0].appendChild(slicedImage);
        slicedImage.addEventListener('load', (event) => {
            const image: HTMLImageElement = event.target as HTMLImageElement;
            const naturalWidth: number = image.naturalWidth / 2;
            sliced3DView.style.width = naturalWidth.toString() + 'px';
        });
    }
}

Sliced3D.instance;